export const DependencyType = {
  QUESTION: "QU",
  OPTION: "OP",
  SUB_OPTION: "SO",
  DIVISION: "DI",
  CUSTOMER: "CU",
  MEDIUM: "ME",
  STAGE: "ST",
};
